<template>
    <div>
        <div class="saving" v-if="saving">
            <LoadingSpinner :loading="saving"/>
        </div>
        <div class="row">
            <div class="col-4">
                <EditPanel v-model="block" :selectedPage="page"/>
            </div>
            <div class="col-8">
                <h2>{{ $t("blocks.name") }}</h2>
                <input class="form-control mb-5 mt-2" v-model="name">
                <Calculation v-model="block" :edit="true" :create="true" :showPages="false" @select-page="updatePage"></Calculation>
                <div class="text-center mt-5">
                    <button class="btn btn-primary" @click="save">Uložit</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Calculation from '@/components/Calculation.vue';
import EditPanel from '@/components/EditPanel.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
export default {
    components: {
        Calculation,
        EditPanel,
        LoadingSpinner
    },
    data() {
        return {
            block: {
                "pages": [
                    {
                        "component": "Div",
                        "text": null,
                        "id": this.createID(18),
                        "class": null,
                        "style": null,
                        "type": null,
                        "calculate": null,
                        "units": null,
                        "hide": false,
                        "disabled": null,
                        "value": null,
                        "options": "",
                        "placeholder": null,
                        "src": null,
                        "href": null,
                        "target": null,
                        "target_id": null,
                        "structure": [
                            {
                                "component": "H1",
                                "text": "Kontaktní údaje",
                                "id": "contactHeading",
                                "class": null,
                                "style": null,
                                "type": null,
                                "calculate": null,
                                "units": null,
                                "hide": false,
                                "disabled": null,
                                "value": null,
                                "structure": [],
                            }]
                    }]
            },
            page: 0,
            name: null,
            saving: false
        }
    },
    methods: {
        createID: function (length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },
        save: function () {
            this.saving = true;
            this.$store.getters.api.post("/block/create", {
                "name": this.name,
                "data": this.block.pages[0]
            }).then(function (response) {
                this.loadData();
                this.saving = false;
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>
